import getDevice from "../../utils/getDevice";
import { processParticleWrapperAttributes } from "./common";

export default function addAssemblerParticle(particleConfig) {
    const {
        mediaHtml,
        bodyHtml,
        bodyAboveMedia,
        headline,
        caption,
        credit,
        is_image,
        class_name,
        publishedAt,
    } = particleConfig;
    const elementContainer = document.createElement("div");
    const header = headline ? `<h3 data-role="headline">${headline}</h3>` : "";
    const bodyHtmlLoad = bodyHtml.replace(/data-runner-src=/gi, "src=");
    const body = bodyAboveMedia ? `${bodyHtmlLoad}${mediaHtml}` : `${mediaHtml}${bodyHtmlLoad}`;

    let creditMarkup = "";
    let captionMarkup = "";

    if (is_image && mediaHtml) {
        creditMarkup = caption
            ? `<small class="image-media media-photo-credit">${caption}</small>`
            : "";
        captionMarkup = credit
            ? `<small class="image-media media-photo-caption">${credit}</small>`
            : "";
    }

    elementContainer.classList.add("rebellt-item", `is-${getDevice()}`);

    if (class_name) {
        elementContainer.classList.add(class_name);
    }

    elementContainer.dataset.isImage = is_image || false;
    elementContainer.dataset.publishedAt = publishedAt;

    processParticleWrapperAttributes(elementContainer, particleConfig);

    elementContainer.innerHTML = `${header}${body}${creditMarkup}${captionMarkup}`;

    return elementContainer;
}
